import { render, staticRenderFns } from "./ReturnsOverviewFilter.vue?vue&type=template&id=cba95d18&"
import script from "./ReturnsOverviewFilter.vue?vue&type=script&lang=ts&"
export * from "./ReturnsOverviewFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports